import { Outlet } from 'react-router-dom';

export const CompanyOutlet = () => <Outlet />;
